module.exports = __webpack_public_path__ + "img/dealify-logo.f44afdf6.png";